import { Cookie } from "@common/components/ProfileBadge/DrawerContent/CookiesManager/AdvancedCookiesDialog/type";

const GTM_ID = __symphony_env__.REACT_APP_GTM_ID;

export const GOOGLE_ANALYTICS_COOKIES: Cookie[] = [
  {
    name: "ANONCHK",
    description:
      "Indicates whether MUID is transferred to ANID, a cookie used for advertising. Clarity doesn't use ANID and so this is always set to 0.",
  },
  {
    name: "MR",
    description: "Indicates whether to refresh MUID.",
  },
  {
    name: "SM",
    description: "Used in synchronizing the MUID across Microsoft domains.",
  },
  {
    name: "MUID",
    description:
      "Identifies unique web browsers visiting Microsoft sites. These cookies are used for advertising, site analytics, and other operational purposes.",
  },
  {
    name: "CLID",
    description:
      "Identifies the first-time Clarity saw this user on any site using Clarity.",
  },
  {
    name: "_ga",
    description:
      "Generates statistical data on website usage, expires after 2 years.",
  },
  {
    name: `_ga_${GTM_ID ? GTM_ID.split("G-")[1] : "<container-id>"}`,
    description:
      "Provides accurate data tracking and analytics within a container, expires after a set duration.",
  },
  {
    name: "_clck",
    description:
      "Persists the Clarity User ID and preferences, unique to that site is attributed to the same user ID.",
  },
  {
    name: "_clsk",
    description:
      "Connects multiple page views by a user into a single Clarity session recording.",
  },
];
